export default "<p>settings works!</p>\n";